import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrdersBlockedComponent } from './orders-blocked/orders-blocked.component';
import { OrdersResendComponent } from './orders-resend/orders-resend.component';
import { ShopOrderDetailComponent } from './shop-order-detail/shop-order-detail.component';
import { ShopOrdersComponent } from './shop-orders.component';

const routes: Routes = [
  {
    path: '',
    component: ShopOrdersComponent
  },
  {
    path: 'orders-blocked',
    component: OrdersBlockedComponent
  },
  {
    path: 'orders-resend',
    component: OrdersResendComponent
  },
  {
    path: ':shop',
    component: ShopOrdersComponent
  },
  {
    path: 'order/:orderId',
    component: ShopOrderDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopOrdersRoutingModule {}
